var exports = {
  "IR": "EntranceSoundSection.module__premiumCard___RGpQTz",
  "fj": "EntranceSoundSection.module__premiumCardHeader___RGpQTz",
  "Xz": "EntranceSoundSection.module__premiumCardIcon___RGpQTz",
  "a1": "EntranceSoundSection.module__premiumCardTitle___RGpQTz",
  "Iq": "EntranceSoundSection.module__premiumCardDescription___RGpQTz",
  "Qs": "EntranceSoundSection.module__content___RGpQTz",
  "eq": "EntranceSoundSection.module__controlPanel___RGpQTz",
  "wZ": "EntranceSoundSection.module__libraryList___RGpQTz",
  "YK": "EntranceSoundSection.module__scopeSection___RGpQTz",
  "Dy": "EntranceSoundSection.module__scopeSectionHeader___RGpQTz",
  "xq": "EntranceSoundSection.module__scopeSectionText___RGpQTz",
  "kd": "EntranceSoundSection.module__scopeSectionLabel___RGpQTz",
  "ij": "EntranceSoundSection.module__scopeHint___RGpQTz",
  "TI": "EntranceSoundSection.module__scopeTileGrid___RGpQTz",
  "F9": "EntranceSoundSection.module__scopeTile___RGpQTz",
  "os": "EntranceSoundSection.module__scopeTileSelected___RGpQTz",
  "MJ": "EntranceSoundSection.module__scopeTileCompact___RGpQTz",
  "gM": "EntranceSoundSection.module__scopeIconWrap___RGpQTz",
  "r2": "EntranceSoundSection.module__scopeIconWrapSelected___RGpQTz",
  "sU": "EntranceSoundSection.module__scopeAvatar___RGpQTz",
  "dd": "EntranceSoundSection.module__scopeAvatarPlaceholder___RGpQTz",
  "rE": "EntranceSoundSection.module__scopeAvatarCompact___RGpQTz",
  "Iz": "EntranceSoundSection.module__scopeTileText___RGpQTz",
  "ZZ": "EntranceSoundSection.module__scopeTileLabel___RGpQTz",
  "Nl": "EntranceSoundSection.module__scopeTileDescription___RGpQTz",
  "bB": "EntranceSoundSection.module__scopeTileCheck___RGpQTz",
  "C6": "EntranceSoundSection.module__communityScopePanel___RGpQTz",
  "hl": "EntranceSoundSection.module__communityScopeHeader___RGpQTz",
  "EP": "EntranceSoundSection.module__communityScopeTitle___RGpQTz",
  "ix": "EntranceSoundSection.module__communityScopeList___RGpQTz",
  "hP": "EntranceSoundSection.module__actionButton___RGpQTz",
  "UG": "EntranceSoundSection.module__soundCard___RGpQTz",
  "MS": "EntranceSoundSection.module__scopeBadge___RGpQTz",
  "zK": "EntranceSoundSection.module__scopeBadgeDirect___RGpQTz",
  "eU": "EntranceSoundSection.module__scopeBadgeInherited___RGpQTz",
  "IM": "EntranceSoundSection.module__inheritedText___RGpQTz",
  "Bv": "EntranceSoundSection.module__soundCardContent___RGpQTz",
  "ZX": "EntranceSoundSection.module__soundCardMain___RGpQTz",
  "ap": "EntranceSoundSection.module__soundStatus___RGpQTz",
  "jc": "EntranceSoundSection.module__previewButton___RGpQTz",
  "mP": "EntranceSoundSection.module__previewIcon___RGpQTz",
  "KM": "EntranceSoundSection.module__soundInfo___RGpQTz",
  "VI": "EntranceSoundSection.module__soundFileName___RGpQTz",
  "yY": "EntranceSoundSection.module__soundDuration___RGpQTz",
  "G5": "EntranceSoundSection.module__deleteButton___RGpQTz",
  "fy": "EntranceSoundSection.module__deleteIcon___RGpQTz",
  "p$": "EntranceSoundSection.module__emptyState___RGpQTz",
  "vo": "EntranceSoundSection.module__emptyStateTitle___RGpQTz",
  "o1": "EntranceSoundSection.module__actions___RGpQTz",
  "J_": "EntranceSoundSection.module__uploadButtonContent___RGpQTz",
};

module.exports = exports;
